import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Test mark 2",
  "description": "",
  "published": "2007-01-05T00:00:00.000Z",
  "redirect_from": ["/blog/test-mark-2/swizec/336"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`BUBBLEWRAP!! XD`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      